<template>
  <el-table-column label="Számlán szereplő dátumok">
    <el-table-column
      prop="issue_date"
      sortable="custom"
      label="Kiállítás"
      show-overflow-tooltip
      min-width="150"
    >
      <template slot-scope="scope">
        {{ scope.row.issue_date | date }}
      </template>
    </el-table-column>
    <el-table-column
      prop="delivery_date"
      sortable="custom"
      label="Teljesítés"
      show-overflow-tooltip
      min-width="150"
    >
      <template slot-scope="scope">
        {{ scope.row.delivery_date | date }}
      </template>
    </el-table-column>
    <el-table-column
      prop="payment_date"
      sortable="custom"
      label="Határidő"
      show-overflow-tooltip
      min-width="150"
    >
      <template slot-scope="scope">
        {{ scope.row.payment_date | date }}
      </template>
    </el-table-column>
  </el-table-column>
</template>

<script>
export default {
  propName: 'delivery_date',
};
</script>
